import { envConfig } from "@env/env-config";


/**
 * @description 匿名用户购物车 Rest配置
 * @deprecated
 */
export const UserCartRestServiceConfig = {
    // 获取购物车数据
    getCart: {
        service: "userCartRestService",
        funcName: "getCart",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart"
        }
    },
    // 批量删除
    multiDelete: {
        service: "userCartRestService",
        funcName: "multiDelete",
        config: {
            method: "delete",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items",
            paramDefaults: { itemIds: "@itemIds" }
        }
    },
    // 获取购物车项列表
    getItemList: {
        service: "userCartRestService",
        funcName: "getItemList",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items"
        }
    },
    // 添加购物车项
    addToCart: {
        service: "userCartRestService",
        funcName: "addToCart",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items"
        }
    },
    // 计算勾选项的结算价格
    totalPrice: {
        service: "userCartRestService",
        funcName: "totalPrice",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items/totalPrice",
            paramDefaults: { itemIds: "@itemIds" }
        }
    },
    // 获取购物车项数量
    totalQty: {
        service: "userCartRestService",
        funcName: "totalQty",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items/totalQty"
        }
    },
    // 移除购物车项
    deleteCartItem: {
        service: "userCartRestService",
        funcName: "deleteCartItem",
        config: {
            method: "delete",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items/:shoppingCartItemId",
            paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
        }
    },
    // 根据id获取指定购物车项
    getItem: {
        service: "userCartRestService",
        funcName: "getItem",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items/:shoppingCartItemId",
            paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
        }
    },
    // 更新购物车项
   
    updateItem: {
        service: "userCartRestService",
        funcName: "updateItem",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items/:shoppingCartItemId",
            paramDefaults: {
                shoppingCartItemId: "@shoppingCartItemId"
            }
        }
    },
    getMultiItems: {
        service: "partnerCartRestService",
        funcName: "getMultiItems",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items",
            paramDefaults: { itemIds: "@itemIds" }
        }
    }
}